import type { CSSProperties } from 'react';
import { colors } from 'styles/theme/colors';

const cellBorderSubtle = `0.5px solid ${colors.grey[200]}`;
const cellBorderError = `0.5px solid ${colors.error[500]}`;

export const DROPDOWN_CELL_BASE: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  minWidth: '120px',
  height: '32px',
  padding: '0 12px',
  gap: '8px',
  boxSizing: 'border-box',
  borderBottom: cellBorderSubtle,
  transition: 'background-color 0.15s',
};

export const DROPDOWN_CELL_HOVER: CSSProperties = {
  backgroundColor: colors.grey[100],
  cursor: 'pointer',
};

export const DROPDOWN_CELL_EDITING: CSSProperties = {
  backgroundColor: colors.white,
  cursor: 'default',
  padding: '0 8px',
};

export const DROPDOWN_CELL_ERROR: CSSProperties = {
  borderBottom: cellBorderError,
};

export const DROPDOWN_CELL_ERROR_TEXT: CSSProperties = {
  color: colors.error[500],
};

export const DROPDOWN_CELL_DISABLED: CSSProperties = {
  backgroundColor: colors.grey[50],
  cursor: 'default',
  pointerEvents: 'none',
  opacity: 0.5,
};

export const DROPDOWN_CELL_DISABLED_TEXT: CSSProperties = {
  color: colors.grey[400],
};

export const DROPDOWN_PLACEHOLDER_STYLE: CSSProperties = {
  color: colors.grey[300],
  fontStyle: 'normal',
};
